import { Box } from '../Common/Box';
import { PaymentMethodEnum } from '@/types/common';
import { useContext } from 'react';
import { CheckoutContext } from '@/context/CheckoutContext';
import { getPaymentMethodLogoUrl } from '@/utils/paymentMethods';

export const P24PayBox = () => {
  const {
    paymentMethodSelected,
    actions: { setPaymentMethodSelected },
  } = useContext(CheckoutContext);
  return (
    <Box
      isSelected={paymentMethodSelected === PaymentMethodEnum.P24}
      onSelect={() => setPaymentMethodSelected(PaymentMethodEnum.P24)}
    >
      <img src={getPaymentMethodLogoUrl(PaymentMethodEnum.P24)} alt="p24" />
    </Box>
  );
};
